// Vite replaces `import.meta.env.X` at build time. Isolating the read here
// lets Jest mock this module (see jest.config.cjs moduleNameMapper), so flag
// consumers always see the empty set in tests.
//
// Local-dev escape hatch: comma-separated flag keys rendered as on without
// LaunchDarkly creds. Dev server only — production builds never honor it.
const raw = import.meta.env.DEV
  ? (import.meta.env['VITE_FEATURE_FLAGS_FORCE_ON'] as string | undefined)
  : undefined;

export const FORCED_ON_FLAGS: ReadonlySet<string> = new Set(
  (raw ?? '')
    .split(',')
    .map((key) => key.trim())
    .filter((key) => key !== ''),
);
